function filterColleagueEmailAddresses(
  emailAddresses: Array<string>,
  ownEmailAddress: Maybe<string>,
) {
  if (!ownEmailAddress) return emailAddresses;

  const [, domain] = ownEmailAddress.split('@');
  if (!domain) return emailAddresses;

  return Array.from(emailAddresses).filter(
    (emailAddress) => !emailAddress?.endsWith(`@${domain}`),
  );
}

export default function detectPossiblePartyEmailAddresses(
  fromEmail: string,
  threadEmails: Array<string>,
  ownEmail?: string,
) {
  const normalized = [...threadEmails, fromEmail].map((email) =>
    email?.replace('mailto:', ''),
  );

  const deduplicated = new Set(normalized);
  const allAddresses = Array.from(deduplicated);

  const withoutColleagues = filterColleagueEmailAddresses(
    allAddresses,
    ownEmail,
  );

  return [withoutColleagues, allAddresses];
}
